// extracted by mini-css-extract-plugin
export default {"block":"detail_block__Q0zOC"};